import { ServiceMaker, methods, services } from "../services";
import { nipige_catalog as API_Nipige_Catalog } from ".";
import Api from "@/services/service-v2";

const { catalog: CatalogService } = services;

export const listCatalog = async (params) => {
  try {
    let result = await API_Nipige_Catalog.get(
      `/api/catalog/read/catalog?${params}`
    );
    return result;
  } catch (error) {
    console.log("error", error);
    return error;
  }
};

export const findByIdCatalog = async (id) => {
  try {
    let result = await API_Nipige_Catalog.get(`/api/catalog/read/detail/${id}`);
    if (result.status === 200) {
      if (result.data.response) return result.data.response;
      else return 0;
    } else return 0;
  } catch (error) {
    console.log("error", error);
    return error;
  }
};

export const fetchTree = () =>
  ServiceMaker("/api/catalog/read/catalog/tree", methods.GET, services.catalog);

export const fetchTenantCatalogTree = () =>
  ServiceMaker(
    "/api/catalog/read/catalog/tree-tenant",
    methods.GET,
    services.catalog
  );

export const fetchPartnerCatalogTree = () =>
  ServiceMaker(
    "/api/catalog/read/catalog/tree-partner",
    methods.GET,
    services.catalog
  );

export const findByProviderIdCatalog = async (condition) => {
  try {
    let result = await API_Nipige_Catalog.post(
      "/api/catalog/read/catalog/find",
      condition
    );
    if (result.status === 200) {
      if (result.data.response) return result.data.response;
      else return 0;
    } else return 0;
  } catch (error) {
    console.log("error", error);
    return error;
  }
};
export const findByProviderIdCatalogItem = async (condition) => {
  try {
    let result = await API_Nipige_Catalog.get(
      "/api/catalog/read/catalog",
      condition
    );
    if (result.status === 200) {
      if (result.data.response) return result.data.response;
      else return 0;
    } else return 0;
  } catch (error) {
    console.log("error", error);
    return error;
  }
};
//catalog
export const findById = (id) =>
  ServiceMaker(`/api/catalog/read/detail/${id}`, methods.GET, CatalogService);

export const createCatalogService = (data) =>
  ServiceMaker(
    "/api/catalog/write/catalog",
    methods.POST,
    services.catalog,
    data
  );

export const updateExternalAttribute = (Id, data) =>
  ServiceMaker(
    `/api/catalog/write/catalog/external-attribute/update/${Id}`,
    methods.PATCH,
    services.catalog,
    data
  );

export const deleteExternalAttribute = (CatalogId, attrId) =>
  ServiceMaker(
    `/api/catalog/write/catalog/external-attribute/delete/${CatalogId}/${attrId}`,
    methods.DELETE,
    services.catalog
  );

export const addExternalAttribute = (Id, data) =>
  ServiceMaker(
    `api/catalog/write/catalog/external-attribute/add/${Id}`,
    methods.PUT,
    services.catalog,
    data
  );

export const setExternalAttribute = (Id, data) =>
  ServiceMaker(
    `api/catalog/write/catalog/external-attribute/set/${Id}`,
    methods.PUT,
    services.catalog,
    data
  );

export const deleteCatalog = (CatalogId) =>
  ServiceMaker(
    `/api/catalog/write/catalog/${CatalogId}`,
    methods.DELETE,
    services.catalog
  );

export const updateCatalog = (Id, data) =>
  ServiceMaker(
    `/api/catalog/write/catalog/update/${Id}`,
    methods.PUT,
    services.catalog,
    data
  );

export const updateOrderAtribute = (payload) =>
  ServiceMaker(
    `/api/catalog/write/catalog/order-attribute/set/${payload.id}`,
    methods.PUT,
    services.catalog,
    payload.data
  );

export const fetchTenantData = (payload) =>
  Api().$http.post(`/cap/users/tenant/get-config`, payload);
